import PropTypes from "prop-types";
import * as React from "react";
import { ClanDescriptionEditDialog, ClanNameEditDialog, RulesDialog } from "UIKit";


const propTypes = {
  clan: PropTypes.shape({
    tag: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    description: PropTypes.string,
    rawDescription: PropTypes.string,
    id: PropTypes.number
  }),
  currentAccount: PropTypes.shape({
    totalGold: PropTypes.number.isRequired,
    isFreeRenameAvailable: PropTypes.bool,
    nextRenameAvailableAt: PropTypes.string
  }).isRequired,
  clanEdit: PropTypes.object,
  error: PropTypes.object,
  dialogType: PropTypes.oneOf(['clanDescription', 'clanName', 'clanColor']).isRequired,

  clanRename: PropTypes.object,
  clansRulesContent: PropTypes.object,

  checkRenamingClanStatus: PropTypes.func,
  onEditDescriptionFormSubmit: PropTypes.func,
  onRenameClanSubmit: PropTypes.func,
  onShowDialog: PropTypes.func,
  onHideDialog: PropTypes.func,
  saveDialogState: PropTypes.func,
  onUpdateFieldValue: PropTypes.func,
  onValidateOnServer: PropTypes.func
};

class ClanEditDialogs extends React.Component {

  constructor(props) {
    super(props);

    this.onClickClansRules = this.onClickClansRules.bind(this);
  }

  getDialogContent(type) {
    const commonDefaults = {
      onCloseClick: this.props.onHideDialog,
      onClickClansRules: this.onClickClansRules,
      saveDialogState: this.props.saveDialogState,
      clansRulesContent: this.props.clansRulesContent
    };

    const savedState = this.props.clanEdit[type] || null;
    let dialogProps = null;
    switch (type) {
      case 'clanDescription':
        dialogProps = Object.assign({}, commonDefaults, {
          description: this.props.clan.description,
          rawDescription: this.props.clan.rawDescription,
          onEditDescriptionFormSubmit: this.props.onEditDescriptionFormSubmit
        });
        return <ClanDescriptionEditDialog {...dialogProps} {...savedState} />;
      case 'clanName':
        dialogProps = Object.assign({}, commonDefaults, {
          clanName: this.props.clan.name,
          clanTag: this.props.clan.tag,
          name: this.props.clanRename.name,
          tag: this.props.clanRename.tag,
          isProcessing: this.props.clanRename.isProcessing,
          error: this.props.clanRename.error,
          currentAccount: this.props.currentAccount,

          checkRenamingClanStatus: this.props.checkRenamingClanStatus,
          onUpdateFieldValue: this.props.onUpdateFieldValue,
          onValidateOnServer: this.props.onValidateOnServer,
          onRenameClanClick: this.props.onRenameClanSubmit
        });
        return <ClanNameEditDialog {...dialogProps} {...savedState} />;
      default:
        return null;

    }
  }

  onClickClansRules() {
    this.props.onHideDialog();
    const RulesDialogContent = <RulesDialog data={this.props.clansRulesContent} onCloseClick={this.props.onHideDialog} />;
    this.props.onShowDialog(RulesDialogContent, 'large');
  }

  render() {
    return this.props.clan ? this.getDialogContent(this.props.dialogType) : null;
  }
}

ClanEditDialogs.propTypes = propTypes;

export default ClanEditDialogs;